import React, {useState} from "react";
import {Button, Input, ModalBody, ModalFooter, ModalHeader, Spinner} from "reactstrap";
import {useAppContext} from "../../hooks";
import {postJsonAxiosService} from "../../services/callAxios";
import {toastService} from "../../services/toast.service";

const WorkableModal = (props) => {
    const {user} = useAppContext();
    const {provider, toggle} = props;
    const [apiToken, setApiToken] = useState("");
    const [errorApiToken, setErrorApiToken] = useState(false);
    const [workableUrl, setWorkableUrl] = useState("");
    const [errorWorkableUrl, setErrorWorkableUrl] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        // Reset error states
        setErrorApiToken(false);
        setErrorWorkableUrl(false);

        // Validate inputs
        if (!apiToken.trim()) {
            setErrorApiToken(true);
            return;
        }
        if (!workableUrl.trim()) {
            setErrorWorkableUrl(true);
            return;
        }

        // Extract subdomain from URL
        let subdomain = '';
        try {
            const url = new URL(workableUrl.trim());
            subdomain = url.hostname.replace('.workable.com', '');
        } catch (error) {
            setErrorWorkableUrl(true);
            return;
        }

        // Create provider object
        let provider = {
            user: user.email,
            accessToken: apiToken.trim(),
            providerId: subdomain,
            provider: "workable",
            service: "ats",
            url: workableUrl.trim()
        }

        try {
            setLoading(true);
            let response = await postJsonAxiosService("workable/webhook/validate", {provider: provider});
            setLoading(false);
            
            if (response) {
                if (!user.providers || user.providers.length === 0) {
                    user.providers = [];
                }
                toastService.info("Workable ATS Integrated Successfully");
                window.location.reload();
            }
        } catch (e: any) {
            setLoading(false);
            const errorMessage = e.response?.data?.error || "Error while updating Workable integration";
            toastService.error(errorMessage);
        }
    };

    return (
        <div style={{padding: 20}}>
            <ModalHeader toggle={props.toggle}
                         style={{fontSize: 24, fontWeight: 600, border: "none"}}>
                <span>Add Workable ATS Integration</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124"}}>
                        <label>API Token</label>
                        <Input 
                            style={{fontSize: 14, color: "#202124"}}
                            placeholder="Enter your Workable API Token"
                            value={apiToken}
                            onChange={(e) => {
                                setApiToken(e.target.value);
                                setErrorApiToken(false);
                            }}
                            invalid={errorApiToken}
                        />
                        {errorApiToken && (
                            <div style={{color: "red", fontSize: 12, marginTop: 5}}>
                                API Token is required
                            </div>
                        )}
                        <div style={{fontSize: 12, color: "#666", marginTop: 5}}>
                            You can find your API token in Workable under Settings → Integrations → API Access Tokens
                        </div>
                    </div>
                    
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124", marginTop: 20}}>
                        <label>Workable URL</label>
                        <Input 
                            style={{fontSize: 14, color: "#202124"}}
                            placeholder="https://yourcompany.workable.com"
                            value={workableUrl}
                            onChange={(e) => {
                                setWorkableUrl(e.target.value);
                                setErrorWorkableUrl(false);
                            }}
                            invalid={errorWorkableUrl}
                        />
                        {errorWorkableUrl && (
                            <div style={{color: "red", fontSize: 12, marginTop: 5}}>
                                Valid Workable URL is required
                            </div>
                        )}
                        <div style={{fontSize: 12, color: "#666", marginTop: 5}}>
                            Enter your full Workable URL (e.g., https://acme.workable.com)
                        </div>
                    </div>

                    <div style={{fontSize: 12, color: "#666", marginTop: 20, padding: 15, backgroundColor: "#f8f9fa", borderRadius: 5}}>
                        <strong>Instructions:</strong>
                        <ol style={{marginTop: 10, paddingLeft: 20}}>
                            <li>Log into your Workable account as a Super Admin</li>
                            <li>Go to Settings → Integrations → API Access Tokens</li>
                            <li>Click "Generate new token"</li>
                            <li>Select the required scopes (r_jobs, r_candidates, r_applications)</li>
                            <li>Copy the API token and enter it above</li>
                            <li>Enter your full Workable URL (e.g., https://yourcompany.workable.com)</li>
                        </ol>
                    </div>

                    <div style={{fontSize: 12, color: "#666", marginTop: 15, padding: 10, backgroundColor: "#fff3cd", borderRadius: 5, border: "1px solid #ffeaa7"}}>
                        <strong>Note:</strong> Make sure you have Super Admin access to generate API tokens. If you don't have the required permissions, contact your Workable administrator.
                    </div>
                </div>
            </ModalBody>
            <ModalFooter style={{border: "none", paddingTop: 0}}>
                <Button
                    className={"btn-typography-primary"}
                    onClick={handleSubmit}
                    disabled={loading}
                    style={{fontSize: 14, fontWeight: 600}}
                >
                    {loading ? (
                        <>
                            <Spinner size="sm" style={{marginRight: 8}} />
                            Integrating...
                        </>
                    ) : (
                        "Add Integration"
                    )}
                </Button>
                <Button
                    className={"btn-typography-secondary"}
                    onClick={toggle}
                    disabled={loading}
                    style={{fontSize: 14, fontWeight: 600}}
                >
                    Cancel
                </Button>
            </ModalFooter>
        </div>
    );
};

export default WorkableModal;
